// src/utils/ArrUtil.ts

class ArrUtil {

    /** 去重
     * @param input 输入数组
     */
    public unique(input: number[]) {
        const uniqueArray = Array.from(new Set(input))
        return uniqueArray
    }

    /** 排序(从小到大)
     * @param input 输入数组
     */
    public sort(input: number[]) {
        return input.sort((a, b) => a - b)
    }

}

export let arrUtil = new ArrUtil()